/**
 * About Page (v0.10.0 - Issue #388)
 * 
 * Personal founder story and mission for ORO MOVE.
 * Features authentic storytelling with community focus.
 */

import { useNavigate } from 'react-router-dom';
import PageLayout from '../components/PageLayout';
import PageHeader from '../components/PageHeader';
import Section from '../components/Section';
import Divider from '../components/Divider';

export default function AboutPage() {
  const navigate = useNavigate();

  return (
    <PageLayout>
      <PageHeader
        title="About ORO"
        subtitle="The story behind the tools"
      />

      <Section showDivider={false}>
        <p className="text-text-secondary leading-relaxed text-lg">
          ORO was built in the hills of West Virginia by a guy who just wanted two simple things: a few equally slow people to run with and weather that cooperates once in a while.
        </p>
        <p className="text-text-secondary leading-relaxed text-lg mt-4">
          Neither dream has fully come true, but hey — we can build some software!
        </p>
        <p className="text-text-secondary leading-relaxed mt-6">
          ORO started the same way most good ideas do:
          someone staring at a dozen broken apps, too many group chats, a calendar that lies, and a burning desire to make community easier.
        </p>
      </Section>

      <Divider />

      <Section 
        title="Who's behind this?"
        headingLevel="h2"
        showDivider={false}
      >
        <div className="space-y-4 text-text-secondary leading-relaxed">
          <p>ORO comes from one slightly-overcommitted founder:</p>
          <div className="pl-4 space-y-3">
            <p>Husband to an amazing, beautiful, tough-as-nails woman who somehow supports all this.</p>
            <p>Tearfully proud dad to three daughters who are lovely in all the measurable ways.</p>
            <p>A sinner saved by grace, taking it one step at a time. (And yes, there's always room in the group run!)</p>
            <p>A lifelong tinkerer who believes local clubs deserve better tools than "Facebook group + hope."</p>
          </div>
        </div>
      </Section>

      <Divider />

      <Section 
        title="Why ORO exists"
        headingLevel="h2"
        showDivider={false}
      >
        <div className="space-y-4 text-text-secondary leading-relaxed">
          <p>Because running and cycling clubs deserve software that cares about THEM.</p>
          <p>Because small communities deserve the same clean, modern tools the giant platforms have — without ads, without data mining, and without making your grandma accidentally join nine WhatsApp threads.</p>
          <p>Because people are better when they move together.</p>
        </div>
      </Section>

      <Divider />

      <Section 
        title="What we're building"
        headingLevel="h2"
        showDivider={false}
      >
        <div className="space-y-4 text-text-secondary leading-relaxed">
          <p>ORO MOVE<sup>™</sup> is a tiny, scrappy, independent project trying to make:</p>
          <div className="pl-4 space-y-2">
            <p>Clubs - simpler to run</p>
            <p>Events - easier to organize</p>
            <p>Showing up - less chaotic</p>
            <p>Community - more meaningful</p>
          </div>
          <div className="mt-6 space-y-2">
            <p>We're not a big tech company.</p>
            <p>We're not VC-funded.</p>
            <p>We're not selling your data to mysterious algorithm trolls.</p>
          </div>
          <p className="mt-4">We're just building the tools we wish existed.</p>
        </div>
      </Section>

      <Divider />

      <Section showDivider={false}>
        <div className="text-center space-y-4">
          <p className="text-text-secondary leading-relaxed text-lg">
            If that sounds like your kind of thing, welcome.
          </p>
          <p className="text-text-primary leading-relaxed text-lg font-medium">
            You're exactly who we're building this for.
          </p>
          <div className="pt-4">
            <button
              onClick={() => navigate('/waitlist')}
              className="bg-accent text-black px-6 py-3 rounded-lg font-medium hover:bg-accent-light transition-colors"
            >
              Join the Waitlist
            </button>
          </div>
        </div>
      </Section>
    </PageLayout>
  );
}